import { render } from "./hazard_basis.vue?vue&type=template&id=d1798138&scoped=true"
import script from "./hazard_basis.vue?vue&type=script&lang=js"
export * from "./hazard_basis.vue?vue&type=script&lang=js"

import "./hazard_basis.vue?vue&type=style&index=0&id=d1798138&lang=scss&scoped=true"
import "./hazard_basis.vue?vue&type=style&index=1&id=d1798138&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1798138"]])

export default __exports__